<template>
<v-container fill-height fluid>

  <v-card
      class="mx-auto"
      max-width="900">
      <v-card-text>
        <v-tabs>
          <v-tab>Short-Term</v-tab>
          <v-tab disabled>Diploma</v-tab>
          <v-tab-item>
            <ShortTermSubPage />

          </v-tab-item>
          <v-tab-item>
            <h3 class="text-center">Unavailable.</h3>
          </v-tab-item>

        </v-tabs>
    </v-card-text>
  </v-card>

</v-container>
</template>

<script>
import ShortTermSubPage from './requirements/ShortTermSubPage'

export default {
  name: 'ShortTermPage',
  components: { ShortTermSubPage }
}
</script>